// extracted by mini-css-extract-plugin
export default {"container":"container-ukIul","profile":"profile-lDJMU","profileHeader":"profileHeader-XJMnW","skeletonProfile":"skeletonProfile-cROj5","skeletonImage":"skeletonImage-zrfvO"};